import * as React from "react";
import Brands, { brandsName } from "./brands/index.js";
import Hero, { heroName } from "./hero.js";
import News, { newsName } from "./news.js";
import Directors, { directorsName } from "./directors.js";
import Awards, { awardsName } from "./awards.js";
import Text, { textName } from "./text.js";
import VisionMission, { visionMissionName } from "./visionMission.js";
import InvestorContacts, { investorContactsName } from "./investorContacts.js";
import JoinUs, { joinUsName } from "./joinUs.js";
import TextIntroduction, { textIntroductionName } from "./textIntroduction.js";
import WorldwideNetwork, { worldWideNetworkName } from "./worldwideNetwork.js";
import Prospectus, { prospectusName } from "./prospectus.js";
import Timeline, { timelineName } from "./timeline.js";
import Announcements, { announcementsName } from "./announcements.js";
import Dividends, { dividendsName } from "./dividends.js";
import CompanyInfo, { companyInfoName } from "./companyInfo.js";
import Introduction, { introductionName } from "./introduction.js";
import Products, { productsName } from "./products.js";
import Map, { mapName } from "./map.js";
import FinancialReports, { financialReportsName } from "./financialReports.js";
import Restaurants, { RestaurantsName } from "./restaurants.js";

const PageSections = ({ sections, setCurrentSection, setAtTop,hrefLang }) => {
  if (!sections) {
    return;
  }

  return sections.map((section, index) => {
    if (!section.internal) {
      return null;
    }

    switch (section.internal.type) {
      case heroName:
        return (
          <Hero
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
            setAtTop={setAtTop}
          />
        );
      // case introductionName:
      //   return <Introduction data={section} key={index} />;
      case newsName:
        return (
          <News
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case textIntroductionName:
        return (
          <TextIntroduction
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case brandsName:
        return (
          <Brands
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
            hrefLang={hrefLang}
          />
        );
      case directorsName:
        return (
          <Directors
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case awardsName:
        return (
          <Awards
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case textName:
        return (
          <Text
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case joinUsName:
        return (
          <JoinUs
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case worldWideNetworkName:
        return (
          <WorldwideNetwork
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case visionMissionName:
        return (
          <VisionMission
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case investorContactsName:
        return (
          <InvestorContacts
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case prospectusName:
        return (
          <Prospectus
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );

      case timelineName:
        return (
          <Timeline
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );

      case announcementsName:
        return (
          <Announcements
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case dividendsName:
        return (
          <Dividends
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case companyInfoName:
        return (
          <CompanyInfo
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case introductionName:
        return (
          <Introduction
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case productsName:
        return (
          <Products
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case mapName:
        return (
          <Map
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case financialReportsName:
        return (
          <FinancialReports
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      case RestaurantsName:
        return (
          <Restaurants
            data={section}
            key={index}
            index={index}
            setCurrentSection={setCurrentSection}
          />
        );
      default:
        return null;
    }
  });
};

export default PageSections;
